<template>
    <div id="emailOverlayDiv">
    </div>
</template>

<script>

//I have copied over the emailoverlay.js file and altered it for use here. This is super janky; see docs below for reasoning.
import {loadEmailOverlay, loadEmailOverlayContent, validForm, validateEmailForm, loadEmailSuccessOverlay} from './emailoverlay'

export default {
  name: 'EmailSharingModal',
  props: {
    //This will need way more props to recieve the necesary information if expanded beyond just the CDM
    coupon:{
      type: Object
    }
  },
  components: {
  },
  data () {
    return {
      //This is currently only enough data to support using this on the coupon modal. Will have to be expanded to take in appropriate data for sharing for other locations.
      srcUrl: '/digital-coupon/coupon-detail/',
      contentDesc:  this.coupon.displayName,
      contentUrl:  this.coupon.imageUrl,
      contentExpDate: this.coupon.expirationDate
    }
  },
  methods: {
    initEmailOverlay(){
      //mirroring the emailoverlay.js way of setting this up but only with pertinent information
      var contentParams = []
      contentParams.srcUrl = this.srcUrl
      contentParams.contentDesc = this.contentDesc
      contentParams.contentUrl = this.contentUrl
      contentParams.contentExpDate = this.contentExpDate

      loadEmailOverlay(this.coupon.couponId,'COUPON', contentParams)
    },
    removePreviousModal(){
      //this is very ugly, please forgive me
      //Doing this because there are multiple copies of this div strewn about the dom, so without removing all of the other one things are being dropped into the wrong place
      //Ideally we would just remove it from where it came, but since we're trying to interfere with everything else as little as possible, it is safer to remove it whenever this vue component runs, so that this can make sure to cover the necesary functionality
      document.querySelectorAll('.modal-email-overlay').forEach(function(a){
        a.remove()
      })
    }
  }, 
  mounted: function () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
    document.head.appendChild(recaptchaScript)
    this.removePreviousModal()
    this.initEmailOverlay()
  },
  computed: {
    
  }
}
</script>

<style lang="scss">
@import "../../assets/lib";
@import "../../../../static-assets/css/emailoverlay";

//styling to fix the form to work in this spot, some of this is repeated from the larger base scss but altered slightly to function here

.modal-heading{
    font-family: "Open Sans";
    font-weight: bold;
}

#recipientEmailLabel{
  width: 100%;
}

.strong{
  font-weight: bold;
}

.input_1{
  min-height: 50px;
  width: 100% !important;
}

.input_1, .input_2{
  width: 100%;
}

.error-message{
  background: url(/img/common/oops.png) no-repeat scroll 25px center #F2DFDE;
  background-size: 30px 30px;
  border: 1px solid #dc291e;
  clear: both;
  color: red;
  padding: 5px 25px 8px 80px;
  border-radius: 4px;
  margin: 1rem 0;
  min-height: 4rem;
}

.error-message p{
  margin-bottom: 0 !important;
}

</style>

<docs>
This vue component is for the vue modal for the form for sharing things via email. It currently is only made to support usage from the CDM.

The way this works is the same as the non-Vue version: it brings in emailtofriendoverlay.jsp into the modal via ajax. This is far from ideal, but there is no email service that we can access, so it is the only option for now

Because of it being a similar implementation but under slightly different circumstances, the emailoverlay.js file responsible for lots of the functionality had to be altered somewhat to fit. Since being able to support all of the possible social sharing situations is currently beyond our current functionality, the file has been copied over into this folder and altered separately. In an ideal world this will take over completely but there are a lot of layers in play here, so best to take it a step at a time.

This being set up this way leads to lot of awkward set up and less than ideal execution in several spots. Any possible optimization here is welcome.
</docs>
